"use strict";
import { Ajax } from "./helpers";
document.addEventListener('DOMContentLoaded', function () {
    /* aktualizace zájezdů */
    const tours = document.getElementById('fn_tours');
    if (tours !== null) {
        const today = tours.getAttribute('data-date'), lastUpdate = tours.getAttribute('data-last-update'), xml = tours.getAttribute('data-xml');
        if (today && lastUpdate && xml && today > lastUpdate) {
            const ajax = new Ajax('GET');
            ajax.request('/ajax.php?refreshTours=1&xml=' + xml, (responseData) => {
                if (responseData.result === 1) {
                    console.log('%c ' + responseData.message, 'color: #598527');
                }
                else {
                    throw new Error(responseData.message);
                }
            }, (error) => {
                console.error('Error:', error);
            });
        }
    }
});
